import {
  Component,
  OnInit,
  Input,
  ElementRef,
  OnDestroy,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  NgZone,
} from '@angular/core';
import { zip } from 'rxjs';
import { AMapService } from '../../shared/amap.service';
import { EventBinderService } from '../../shared/event-binder.service';
import { PluginLoaderService } from '../../shared/plugin-loader.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { getOptions, ChangeFilter } from '../../utils';

const TAG = 'ngx-amap';
const ALL_OPTIONS = [
  'view',
  'layers',
  'zoom',
  'center',
  'labelzIndex',
  'zooms',
  'lang',
  'defaultCursor',
  'crs',
  'animateEnable',
  'isHotspot',
  'defaultLayer',
  'rotateEnable',
  'resizeEnable',
  'showIndoorMap',
  'indoorMap',
  'expandZoomRange',
  'dragEnable',
  'zoomEnable',
  'doubleClickZoom',
  'keyboardEnable',
  'jogEnable',
  'scrollWheel',
  'touchZoom',
  'touchZoomCenter',
  'mapStyle',
  'features',
  'showBuildingBlock',
  'viewMode',
  'pitch',
  'pitchEnable',
  'buildingAnimation',
  'skyColor',
  'preloadMode',
  'mask',
  'maxPitch',
  'rotation',
  'forceVector',
  'gridMapForeign',
  'vectorMapForeign',
];

@Component({
  selector: 'ngx-amap',
  exportAs: 'amap',
  templateUrl: './ngx-amap.component.html',
  styleUrls: ['./ngx-amap.component.scss'],
  providers: [AMapService, PluginLoaderService],
})
export class NgxAmapComponent implements OnInit, OnDestroy, OnChanges {
  // ---- Map Options ----
  /**
   * å°å¾è§å£ï¼ç¨äºæ§å¶å½±åå°å¾éææ¾ç¤ºçå±æ§
   */
  @Input() view: AMap.View2D;
  /**
   * å°å¾å¾å±æ°ç»ï¼æ°ç»å¯ä»¥æ¯å¾å± ä¸­çä¸ä¸ªæå¤ä¸ªï¼é»è®¤ä¸ºæ®éäºç»´å°å¾
   */
  @Input() layers: AMap.Layer[];
  /**
   * å°å¾æ¾ç¤ºçç¼©æ¾çº§å«
   */
  @Input() zoom: number;
  /**
   * å°å¾ä¸­å¿ç¹åæ å¼
   */
  @Input() center: AMap.LocationValue;
  /**
   * å°å¾æ æ³¨æ¾ç¤ºé¡ºåº
   */
  @Input() labelzIndex: number;
  /**
   * å°å¾æ¾ç¤ºçç¼©æ¾çº§å«èå´
   */
  @Input() zooms: [number, number];
  /**
   * å°å¾è¯­è¨ç±»å
   */
  @Input() lang: AMap.Lang;
  /**
   * å°å¾é»è®¤é¼ æ æ ·å¼
   */
  @Input() defaultCursor: string;
  /**
   * å°å¾æ¾ç¤ºçåèåæ ç³»
   */
  @Input() crs: 'EPSG3857' | 'EPSG3395' | 'EPSG4326';
  /**
   * å°å¾å¹³ç§»è¿ç¨ä¸­æ¯å¦ä½¿ç¨å¨ç»
   */
  @Input() animateEnable: boolean;
  /**
   * æ¯å¦å¼å¯å°å¾ç­ç¹åæ æ³¨çhoverææ
   */
  @Input() isHotspot: boolean;
  /**
   * å½åå°å¾ä¸­é»è®¤æ¾ç¤ºçå¾å±
   */
  @Input() defaultLayer: AMap.TileLayer;
  /**
   * å°å¾æ¯å¦å¯æè½¬
   */
  @Input() rotateEnable: boolean;
  /**
   * æ¯å¦çæ§å°å¾å®¹å¨å°ºå¯¸åå
   */
  @Input() resizeEnable: boolean;
  /**
   * æ¯å¦å¨æç¢éåºå¾çæ¶åèªå¨å±ç¤ºå®¤åå°å¾
   */
  @Input() showIndoorMap: boolean;
  /**
   * å¨å±ç¤ºç¢éå¾çæ¶åèªå¨å±ç¤ºå®¤åå°å¾å¾å±
   */
  @Input() indoorMap: any;
  /**
   * æ¯å¦æ¯æå¯ä»¥æ©å±æå¤§ç¼©æ¾çº§å«
   */
  @Input() expandZoomRange: boolean;
  /**
   * å°å¾æ¯å¦å¯éè¿é¼ æ ææ½å¹³ç§»
   */
  @Input() dragEnable: boolean;
  /**
   * å°å¾æ¯å¦å¯ç¼©æ¾
   */
  @Input() zoomEnable: boolean;
  /**
   * å°å¾æ¯å¦å¯éè¿åå»é¼ æ æ¾å¤§å°å¾
   */
  @Input() doubleClickZoom: boolean;
  /**
   * å°å¾æ¯å¦å¯éè¿é®çæ§å¶
   */
  @Input() keyboardEnable: boolean;
  /**
   * å°å¾æ¯å¦ä½¿ç¨ç¼å¨ææ
   */
  @Input() jogEnable: boolean;
  /**
   * å°å¾æ¯å¦å¯éè¿é¼ æ æ»è½®ç¼©æ¾æµè§
   */
  @Input() scrollWheel: boolean;
  /**
   * å°å¾å¨ç§»å¨ç»ç«¯ä¸æ¯å¦å¯éè¿å¤ç¹è§¦æ§ç¼©æ¾æµè§å°å¾
   */
  @Input() touchZoom: boolean;
  /**
   * å½touchZoomCenter=1çæ¶åï¼ææºç«¯åæç¼©æ¾çä»¥å°å¾ä¸­å¿ä¸ºä¸­å¿ï¼å¦åé»è®¤ä»¥åæä¸­é´ç¹ä¸ºä¸­å¿
   */
  @Input() touchZoomCenter: number;
  /**
   * è®¾ç½®å°å¾çæ¾ç¤ºæ ·å¼
   */
  @Input() mapStyle: string;
  /**
   * è®¾ç½®å°å¾ä¸æ¾ç¤ºçåç´ ç§ç±»
   */
  @Input() features: AMap.Map.Feature[] | 'all' | AMap.Map.Feature;
  /**
   * è®¾ç½®å°å¾æ¾ç¤º3Dæ¥¼åææ
   */
  @Input() showBuildingBlock: boolean;
  /**
   * è§å¾æ¨¡å¼
   */
  @Input() viewMode: AMap.Map.ViewMode;
  /**
   * ä¿¯ä»°è§åº¦
   */
  @Input() pitch: number;
  /**
   * æ¯å¦åè®¸è®¾ç½®ä¿¯ä»°è§åº¦
   */
  @Input() pitchEnable: boolean;
  /**
   * æ¥¼ååºç°åæ¶å¤±çæ¶åæ¯å¦æ¾ç¤ºå¨ç»è¿ç¨
   */
  @Input() buildingAnimation: boolean;
  /**
   * è°æ´å¤©ç©ºé¢è²
   */
  @Input() skyColor: string;
  /**
   * è®¾ç½®å°å¾çé¢å è½½æ¨¡å¼
   */
  @Input() preloadMode: boolean;
  /**
   * ä¸º Map å®ä¾æå®æ©æ¨¡çè·¯å¾ï¼åå¾å±å°åªæ¾ç¤ºè·¯å¾èå´åå¾å
   */
  @Input() mask: [number, number][] | [number, number][][] | [number, number][][][];
  @Input() maxPitch: number;
  @Input() rotation: number;
  @Input() forceVector: boolean;
  @Input() gridMapForeign: boolean;
  /**
   * é¢å¤: æµ·å¤â½®éå°å¾æ ·å¼
   */
  @Input() vectorMapForeign: string;

  /**
   * é¢å¤: è®¾ç½®åå¸
   */
  @Input() city: string;
  /**
   * é¢å¤: è®¾ç½®å°å¾å
   */
  @Input() name: string;
  /**
   * é¢å¤ï¼å è½½æä»¶
   */
  @Input() plugins: string[];

  // ---- Map Events ----
  @Output() naReady = new EventEmitter();
  @Output() naComplete: EventEmitter<any>;
  @Output() naClick: EventEmitter<any>;
  @Output() naDblClick: EventEmitter<any>;
  @Output() naRightClick: EventEmitter<any>;
  @Output() naMouseMove: EventEmitter<any>;
  @Output() naMouseOver: EventEmitter<any>;
  @Output() naMouseWheel: EventEmitter<any>;
  @Output() naMouseUp: EventEmitter<any>;
  @Output() naMouseOut: EventEmitter<any>;
  @Output() naMouseDown: EventEmitter<any>;
  @Output() naTouchStart: EventEmitter<any>;
  @Output() naTouchMove: EventEmitter<any>;
  @Output() naTouchEnd: EventEmitter<any>;
  @Output() naHotspotClick: EventEmitter<any>;
  @Output() naHotspotOver: EventEmitter<any>;
  @Output() naHotspotOut: EventEmitter<any>;
  @Output() naDragStart: EventEmitter<any>;
  @Output() naDragging: EventEmitter<any>;
  @Output() naDragEnd: EventEmitter<any>;
  @Output() naResize: EventEmitter<any>;
  @Output() naZoomStart: EventEmitter<any>;
  @Output() naZoomEnd: EventEmitter<any>;
  @Output() naZoomChange: EventEmitter<any>;
  @Output() naMoveStart: EventEmitter<any>;
  @Output() naMoveEnd: EventEmitter<any>;
  @Output() naMove: EventEmitter<any>;
  @Output() naPluginsLoaded = new EventEmitter<AMap.Map>();

  private inited = false;

  constructor(
    private el: ElementRef,
    private amap: AMapService,
    private pluginLoader: PluginLoaderService,
    private logger: LoggerService,
    private binder: EventBinderService,
    private ngZone: NgZone,
  ) {
    const m = this.amap.get();
    this.naComplete = this.binder.bindEvent(m, 'complete');
    this.naClick = this.binder.bindEvent(m, 'click');
    this.naDblClick = this.binder.bindEvent(m, 'dblclick');
    this.naRightClick = this.binder.bindEvent(m, 'rightclick');
    this.naMouseMove = this.binder.bindEvent(m, 'mousemove');
    this.naMouseOver = this.binder.bindEvent(m, 'mouseover');
    this.naMouseWheel = this.binder.bindEvent(m, 'mousewheel');
    this.naMouseUp = this.binder.bindEvent(m, 'mouseup');
    this.naMouseOut = this.binder.bindEvent(m, 'mouseout');
    this.naMouseDown = this.binder.bindEvent(m, 'mousedown');
    this.naTouchStart = this.binder.bindEvent(m, 'touchstart');
    this.naTouchMove = this.binder.bindEvent(m, 'touchmove');
    this.naTouchEnd = this.binder.bindEvent(m, 'touchend');
    this.naHotspotClick = this.binder.bindEvent(m, 'hotspotclick');
    this.naHotspotOver = this.binder.bindEvent(m, 'hotspotover');
    this.naHotspotOut = this.binder.bindEvent(m, 'hotspotout');
    this.naDragStart = this.binder.bindEvent(m, 'dragstart');
    this.naDragging = this.binder.bindEvent(m, 'dragging');
    this.naDragEnd = this.binder.bindEvent(m, 'dragend');
    this.naResize = this.binder.bindEvent(m, 'resize');
    this.naZoomStart = this.binder.bindEvent(m, 'zoomstart');
    this.naZoomEnd = this.binder.bindEvent(m, 'zoomend');
    this.naZoomChange = this.binder.bindEvent(m, 'zoomchange');
    this.naMoveStart = this.binder.bindEvent(m, 'movestart');
    this.naMoveEnd = this.binder.bindEvent(m, 'moveend');
    this.naMove = this.binder.bindEvent(m, 'mapmove');
  }

  ngOnInit() {
    this.logger.d(TAG, 'initializing ...');
    const container = this.el.nativeElement.querySelector('div.ngx-amap-container-inner');
    const options = getOptions<AMap.Map.Options>(this, ALL_OPTIONS);
    this.logger.d(TAG, 'options:', options);
    this.amap.create(container, options).subscribe(amap => {
      this.logger.d(TAG, 'map is ready.');
      this.ngZone.run(() => this.naReady.emit(amap));
    });
    this.inited = true;
  }

  ngOnDestroy() {
    this.amap.destroy();
  }

  ngOnChanges(changes: SimpleChanges) {
    const filter = ChangeFilter.of(changes);
    const amap = this.get();

    if (this.inited) {
      zip(filter.has<number>('zoom'), amap).subscribe(([v, m]) => {
        this.logger.d(TAG, 'setZoom:', v);
        m.setZoom(v);
      });
      zip(filter.has<AMap.LocationValue>('center'), amap).subscribe(([v, m]) => {
        this.logger.d(TAG, 'setCenter:', v);
        m.setCenter(v);
      });
    }

    // Not included in OPTIONS
    zip(filter.has<string>('city'), amap).subscribe(([v, m]) => {
      m.setCity(v, () => {
        this.logger.d(TAG, 'setCity:', v);
      });
    });
    zip(filter.notEmpty<string[]>('plugins'), amap).subscribe(([v, m]) => {
      this.pluginLoader.load(v).subscribe(() => {
        this.logger.d(TAG, 'plugins loaded.');
        this.ngZone.run(() => this.naPluginsLoaded.emit(m));
      });
    });
  }

  /**
   * è·åå·²åå»ºç AMap.Map å¯¹è±¡
   */
  get() {
    return this.amap.get();
  }
}
